<template>
  <div class="headerDiv">
    <div class="cuibanner" tabindex="0" aria-label="CUI - CONTROLLED UNCLASSIFIED INFORMATION">
      CUI - CONTROLLED UNCLASSIFIED INFORMATION
    </div>

    <div class="debuggingBanner" v-if="debugging">ALERT: Developer Debug flag set to TRUE. (login/healthcheck are automatically set to TRUE)</div>

    <nav class="navbar mainNav">
      <div style="flex-wrap: nowrap;">
        <img src="CAAMSWheelWhite.png" class="logoImage" alt=""/>
        <div tabindex="0" class="caamsText" aria-label="Civilian Arming Authorization Management System">Civilian Arming Authorization Management System</div>
      </div>

      <div id="loginButtonContainer" v-if="displayLoginButtonContainer">

        <div tabindex="0" id="loginFormContainer" class="pe-2">
          <LoginForm></LoginForm>
        </div>

        <div v-if="!store.loggedIn" class="d-flex">
          <div class="pe-2">
            <RegistrationForm modal-id="RegModal" modal-title="Register" aria-label="Click to Register"></RegistrationForm>
          </div>
          <div>
            <RegistrationForm :with-cac="true" modal-id="RegModalCac" modal-title="Register with CAC"></RegistrationForm>
          </div>
        </div>

      </div>
    </nav>
  </div>
</template>

<script>
import LoginForm from "../Login/LoginForm.vue";
import RegistrationForm from "../Login/RegistrationForm.vue";
import { store } from "../../store/store.js";

export default {
  name: "AppHeader",
  components: {
    LoginForm,
    RegistrationForm,
  },
  props: {
    navHeight: Number,
  },
  data() {
    return {
      store,
    };
  },
  computed:{
    debugging(){
      if(this.store.globalDebugging != null){
        return this.store.globalDebugging; 
      }
      else{
        return false;
      }
    },
    displayLoginButtonContainer(){
      if(this.store.healthStatus.healthyYN == true || this.debugging){
        return true;
      }

      return false;
    }
  },
  methods: {
    LogoffUser() {
      store.loggedIn = false;
      store.authenticatedUser = {};
    }
  }
};
</script>

<style scoped>

.helpButton {
  background-color: darkblue;
  color: #DC143C;
}

.logoImage {
  width: 40px;
}

.userFont {
  color: rgb(200, 199, 199);
  font-size: 16px;
}

.userDiv {
  display: inline-block;
  vertical-align: middle;
}

.caamsText {
  display: inline-block;
  color: rgb(200, 199, 199);
  font-size: 18px;
  margin-left: 15px;
  vertical-align: middle;
}

.mainNav {
  display: flex;
  flex-direction: row;


  margin: 0;
  border-style: solid;
  border-width: 1px;
  padding: 5px;
  /* flex-wrap: nowrap; */
  background-image: linear-gradient(to right, #1063a8, #003a6c);

}

#loginButtonContainer {
  display: flex;
  justify-content: space-around;
  flex-shrink: 0;
}

/* CUI banner - color is from official DoD guidelines */
.cuibanner {
  background-color: #502B85;
  color: white;
  text-align: center;
}

/*  This ensures the nav menu and main content are positioned as desired
    Adjust this value to increase/decrease the space under the header  */
.headerDiv {
  margin-bottom: -50px;
  min-width: none;
  max-width: none;
}
.debuggingBanner{
  color:white;
  background-color: orange;
}
</style>
